// Shared image variant arrays for listing page contexts.
// Avoids duplicating variant lists across SectionHero, SectionGallery, and ListingPageCoverPhoto.

// 1:1 square-cropped variants for hero / gallery main image display, ladder
// 400/640/800/1280/1600/2048. listing-card* rungs are square because the Console
// listing-image ratio is 1:1 (revisit if that changes); they also let the hero
// paint instantly from the search-page cache after client-side navigation.
export const SQUARE_VARIANTS = [
  'listing-card',
  'listing-card-2x',
  'listing-card-4x',
  'listing-square',
  'listing-square-2x',
  'listing-square-3x',
];

// Small square variant for the desktop thumbnail strip (84 px rendered).
// Falls back to listing-square (640 w) if the thumb variant isn't available.
export const THUMBNAIL_VARIANTS = [
  'listing-square-thumb',
  'listing-square',
];

// Uncropped high-res variants for fullscreen / lightbox viewing (750/1024/1500/2400).
export const FULLSCREEN_VARIANTS = [
  'scaled-medium',
  'scaled-large',
  'scaled-1500',
  'scaled-xlarge',
];
